import { render, staticRenderFns } from "./newsletterI.vue?vue&type=template&id=15f14fcc"
import script from "./newsletterI.vue?vue&type=script&lang=js"
export * from "./newsletterI.vue?vue&type=script&lang=js"
import style0 from "./newsletterI.vue?vue&type=style&index=0&id=15f14fcc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports